import {env} from '@px/helper/env';

interface TingYun {
  setUid(userId: string): void;
  // TODO: remove
  newAction({key: string, duration: number}, flag: boolean): void;
  newEvent(options: {name: string; msg: string; status: string; context: Record<string, string | number>}): void;
}

declare global {
  interface Window {
    TINGYUN: TingYun;
  }
}

const showLog = env.isBrowser && localStorage.getItem('ty_show_log') === 'Y';

export const ty = {
  setUid(userId) {
    const tingYun = window.TINGYUN;
    if (tingYun && tingYun.setUid) {
      showLog && console.log('[TY] SetUid:', userId);
      tingYun.setUid(userId);
    }
  },
  createEvent(options: TyMsg) {
    if (document.visibilityState !== 'visible') {
      showLog && console.log('[TY] ignore NewAction:', options);
      return;
    }

    const tingYun = window.TINGYUN;
    if (tingYun && tingYun.newEvent) {
      showLog && console.log('[TY] newEvent:', options);
      // TODO: remove
      tingYun.newAction({key: options.phase, duration: options.duration}, true);
      tingYun.newEvent({
        name: 'ws_connection',
        msg: '',
        status: 'success',
        context: {
          ...options,
          url: window.location.href,
        },
      });
    }
  },
};
